import { forwardRef } from "react";
import type { HTMLAttributes } from "react";

interface ProjectGridProps extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const ProjectGrid = forwardRef<HTMLDivElement, ProjectGridProps>(
  ({ children, className = "", ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={`flex gap-6 overflow-x-auto pb-4 scroll-smooth ${className}`}
        style={{
          scrollbarWidth: "thin",
          scrollbarColor: "#000 #fff",
        }}
        {...props}
      >
        {children}
      </div>
    );
  }
);

ProjectGrid.displayName = "ProjectGrid";

export default ProjectGrid;
